<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<h1 mat-dialog-title>{{title}}</h1>
<div class="default-padding">
  <form [formGroup]="addMktAreaForm">
    <mat-form-field>
      <mat-label>Market Area</mat-label>
      <mat-hint>Required</mat-hint>
      <input matInput formControlName="newValue" id="new-value"/>
      <mat-error *ngIf="addMktAreaForm.get('newValue').hasError('required')">
        A value is <strong>required</strong>.
      </mat-error>
    </mat-form-field>
    <br/>

    <mat-form-field>
      <mat-label>Available Planning Markets</mat-label>
      <fab-multiselect
        formControlName="planningMarketMappingList"
        [options]="this.planningMarkets.options"
      >
      </fab-multiselect>
      <mat-error *ngIf="addMktAreaForm.get('planningMarketMappingList').hasError('required')">
        A value is <strong>required</strong>.
      </mat-error>
    </mat-form-field>
    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" id="add-button" class="action-button"
              (click)="addValue()" [disabled]="!addMktAreaForm.valid">
        Add
      </button>
    </div>
  </form>
</div>
<div mat-dialog-content class="popUp d-flex">
  <div class="gfs-table w-100">
    <mat-table id="mainTable" [dataSource]="dataSource"
               aria-label="Add Market Area Planning Market Map Table">

        <ng-container matColumnDef="plngMkt">
          <mat-header-cell *matHeaderCellDef> Planning Markets</mat-header-cell>
          <mat-cell *matCellDef="let element; let i = index"> {{ element }}</mat-cell>
        </ng-container>
      <ng-container matColumnDef="footer" [sticky]="true">
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <mat-footer-row class="bottom-border" *matFooterRowDef="['footer']; sticky: true"></mat-footer-row>
    </mat-table>
    </div>


</div>
